/**
 * Sanftes Einblenden beim Scrollen: Karten, Bänder und Spalten gleiten 14 px ein.
 * Aus bei „Bewegung reduzieren“ und im Theme-Editor. Was beim Laden schon im Bild ist, bleibt unberührt.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify?.designMode) return;
  if (!('IntersectionObserver' in window)) return;

  const ziele = document.querySelectorAll(
    '.e-karte, .e-feature__bild, .e-feature__text, .e-testteam__kopf, .e-testteam__form, .e-duft__spalte, .e-tafel, .e-usp__punkt'
  );
  const hoehe = window.innerHeight;
  const beobachter = new IntersectionObserver(
    (eintraege) => {
      for (const eintrag of eintraege) {
        if (!eintrag.isIntersecting) continue;
        eintrag.target.classList.add('e-in');
        beobachter.unobserve(eintrag.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  for (const ziel of ziele) {
    if (ziel.getBoundingClientRect().top < hoehe) continue;
    const geschwister = ziel.parentElement ? [...ziel.parentElement.children].indexOf(ziel) : 0;
    ziel.style.setProperty('--e-verzoegerung', `${Math.min(geschwister, 4) * 70}ms`);
    ziel.classList.add('e-reveal');
    beobachter.observe(ziel);
  }

  // Höhenprofile werden von links nach rechts aufgedeckt, das Fähnchen kommt zuletzt.
  for (const profil of document.querySelectorAll('.e-profil')) {
    if (profil.getBoundingClientRect().top < hoehe) continue;
    profil.classList.add('e-profil--vor');
    beobachter.observe(profil);
  }
})();
